import { Switch as SwitchPrimitive } from '@base-ui/react/switch';
export function Switch({ checked, onChange, label, disabled = false }: {
    checked: boolean;
    onChange: (checked: boolean) => void;
    label: string;
    disabled?: boolean;
}) {
    return <SwitchPrimitive.Root checked={checked} onCheckedChange={onChange} aria-label={label} disabled={disabled} className="ui-switch"><SwitchPrimitive.Thumb className="ui-switch-thumb"/></SwitchPrimitive.Root>;
}
